<template>
  <VAppLayout>
    <VPageHeader :title="$t('pages.cart.orderHistory')" back @back="goBack">
      <template #badge>
        <span class="section_title-badge"
              :class="{hidden: computedTableNum === null}">
          {{ `${$t('pages.cart.table')}: ${computedTableNum}` }}
        </span>
      </template>
    </VPageHeader>

    <VContainer>
      <section
          class="cart">
        <div
            class="cart_list" v-for="order in computedOrders" :key="order.id" >
          <span class="order_title">{{ $t('pages.cart.order') }} #{{order.order_number}} <span class="order_details">({{order.updated_at}}, {{getOrderTotal(order)}})</span></span>
          <div class="cart_list-total">
          </div>
          <ul>
            <li>
              <ul>
                <li
                    v-for="orderItem in order.items"
                    :key="orderItem.id">
                  <p :class="{'subproduct': orderItem.parent_id !== null }">
                    <small>{{ `${getItemQuantity(orderItem)}  x` }}</small> {{ orderItem.product.name }}
                  </p>
                  <em>
                    {{ formatPrice(getItemQuantitySum(orderItem)) }}
                  </em>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </section>
    </VContainer>
  </VAppLayout>
</template>


<script>
// import VCartItem from "@/modules/cart/components/VCartItem.vue";
// import VButton from "@/components/ui/VButton.vue";
import VAppLayout from "@/layouts/VAppLayout.vue";
import VContainer from "@/components/ui/VContainer.vue";
import VPageHeader from "@/components/ui/VPageHeader.vue";

export default {
  name: "History",
  components: {
    VContainer,
    VPageHeader,
    VAppLayout,
    // VButton,
    // VCartItem
  },
  data() {
    return {}
  },
  mounted() {
    this.$store.dispatch('cartStore/FETCH_ORDERS_HISTORY', this.$store)

  },
  computed: {
    computedTableNum: function () {
      return this.$store.getters['getTableName']
    },
    computedCompanyData: function () {
      return this.$store.getters['getCompanyData']
    },
    computedOrders: function () {
        return this.$store.getters["cartStore/getHistory"];
    }
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat('pl-PL', {style: 'currency', currency: 'PLN'}).format(price)
    },
    getItemQuantity(orderItem) {
      return orderItem.quantity ? orderItem.quantity : orderItem.count
    },
    getItemQuantitySum(orderItem) {
      return orderItem.amount ? orderItem.amount : orderItem.count * orderItem.product.price;
    },
    getOrderTotal(order) {
      // var total = 0;
      // order.items.forEach(item => {
      //   total = total + parseFloat(item.amount);
      // });
      return this.formatPrice(order.sum)
    },
    goBack() {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
ul, li, h6 {
  margin: 0;
  padding: 0;
  list-style: none;
}

.cart {
  box-sizing: border-box;
  padding: 24px 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  /* viewport units, not %: the document scrolls, ancestor heights are content-driven */
  min-height: 100vh;
  min-height: 100svh;
}

.section_title-badge {
  display: inline-flex;
  align-items: center;

  padding: 4px 12px;
  border-radius: var(--radius-pill);

  font-size: var(--text-xs);
  font-weight: var(--weight-bold);

  background: var(--color-primary-soft);
  color: var(--color-primary);

  &.hidden {
    visibility: hidden;
  }
}


.cart_plug {
  text-align: center;
  height: 100%;
  padding-top: 25%;

  .empty-cart-title {
    padding: 10% 0 5% 0;
    font-size: var(--text-2xl);
    font-weight: var(--weight-black);
    color: var(--text-primary);
  }
}

.cart_list {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--border-subtle);
  padding: 18px;
  gap: 12px;
  border-radius: 22px;
  box-shadow: 0 6px 18px rgba(74, 55, 73, 0.06);
  background: var(--surface-card);

  & > ul {
    display: flex;
    flex-direction: column;
    gap: 30px;

    li {
      width: 100%;

      p.subproduct {
        padding-left: 20px;
      }

      & > span {
        display: block;
        text-align: center;
        font-weight: var(--weight-bold);
        font-size: var(--text-md);
        color: var(--text-primary);
      }

      & > ul {
        display: flex;
        flex-direction: column;
        gap: 12px;

        li {
          display: flex;
          justify-content: space-between;
          align-items: center;

          p {
            color: var(--text-primary);
            font-size: var(--text-base);
            font-weight: var(--weight-medium);
            margin: 0;

            small {
              color: var(--color-primary);
              font-size: var(--text-base);
              font-weight: var(--weight-semibold);
            }

          }

          em {
            color: var(--text-price);
            font-size: var(--text-base);
            font-style: normal;
            font-weight: var(--weight-bold);
          }
        }
      }
    }
  }

  .cart_list-total {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: var(--text-primary);

    span {
      font-weight: var(--weight-bold);
      font-size: var(--text-md);
    }
  }
}


.order_title {
  font-size: var(--text-lg);
  font-weight: var(--weight-bold);
  line-height: 1.1;
  color: var(--text-primary);

  .order_details {
    font-size: var(--text-base);
    font-weight: var(--weight-medium);
    color: var(--color-primary);
  }
}

</style>
